export default __webpack_public_path__ + "1bc158643480633ac3a5b258dd5c0daa.svg";